enum TimesheetsTotalUnitTimeEnum {
  MINUTE = 'minute',
  SECOND = 'second',
  HOUR = 'hour',
}

export default TimesheetsTotalUnitTimeEnum
